import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminMe } from './api';

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem('gd_admin_token');
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await adminMe();
      setUser(me);
    } catch (_) {
      localStorage.removeItem('gd_admin_token');
      setUser(null);
    }
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const login = (token, email) => {
    localStorage.setItem('gd_admin_token', token);
    setUser({ email });
  };

  const logout = () => {
    localStorage.removeItem('gd_admin_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AuthContext);
